import { createSelector } from 'reselect'

import { selectOfferingsMode } from './selectOfferingsMode'
import { selectPartner360Data } from './selectPartner360Data'
import { selectProgramType } from './selectProgramType'

/**
 * @deprecated - better to use selectors separate (e.g. selectFinancialYear, selectProgramOffering, etc.)
 * */
export const selectParameters = createSelector(
  [selectPartner360Data, selectProgramType, selectOfferingsMode],
  ({ partnerId, fYear }, programType, isNewOfferings) => ({
    partnerId,
    fYear,
    programType,
    isNewOfferings,
  })
)
